export const CONTENT_VERSION = '0.0.1';

let curriculum = {};
let onboarding = {};
let characters = {};

export const setCurriculum = (newVersion) => { curriculum = newVersion; };
export const setOnboarding = (newVersion) => { onboarding = newVersion; };
export const setCharactersSet = (newVersion) => { characters = newVersion; };

export const getCurriculum = () => curriculum;
export const getOnboarding = () => onboarding;
export const getCharactersSet = () => characters;
export const getLevelCount = () => {
  if (curriculum.levels === undefined) {
    return 0;
  }
  return curriculum.levels.length;
};
